import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ShieldCheck, Lock, Smartphone, Star } from "lucide-react";

const SIDES = [
  "https://images.unsplash.com/photo-1622801085474-441502629217?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtdXNsaW0lMjBicmlkZSUyMGdyb29tJTIwbmlrYWglMjB3ZWRkaW5nJTIwZWxlZ2FudHxlbnwwfHx8fDE3OTA5NzY1MjN8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1644337111604-aa1816b542a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxtdXNsaW0lMjBicmlkZSUyMGdyb29tJTIwbmlrYWglMjB3ZWRkaW5nJTIwZWxlZ2FudHxlbnwwfHx8fDE3OTA5NzY1MjN8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1670014235502-08593dc092b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxtdXNsaW0lMjBicmlkZSUyMGdyb29tJTIwbmlrYWglMjB3ZWRkaW5nJTIwZWxlZ2FudHxlbnwwfHx8fDE3OTA5NzY1MjN8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1658731438848-b2766294498c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtdXNsaW0lMjBicmlkZSUyMGdyb29tJTIwbmlrYWglMjB3ZWRkaW5nJTIwZWxlZ2FudHxlbnwwfHx8fDE3OTA5NzY1MjN8MA&ixlib=rb-4.1.0&q=85",
];
const SIDE = SIDES[Math.floor(Math.random() * SIDES.length)];

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-ivory p-3 sm:p-4">
      <div className="mx-auto flex min-h-[calc(100vh-1.5rem)] max-w-6xl overflow-hidden rounded-3xl border border-emerald-900/10 bg-white shadow-sm sm:min-h-[calc(100vh-2rem)]">
        {/* Left visual */}
        <div className="relative hidden w-1/2 lg:block">
          <img src={SIDE} alt="A Muslim couple" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/95 via-emerald-950/40 to-emerald-950/15" />
          <Link to="/" className="absolute left-8 top-8"><Logo dark size="lg" /></Link>
          <div className="absolute inset-x-0 bottom-0 p-8">
            <div className="rounded-3xl bg-emerald-950/45 p-6 glass ring-1 ring-white/10">
              <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-amber-200"><Star className="h-3.5 w-3.5" /> Find Your Partner • Build Your Future</span>
              <h2 className="font-serif text-4xl font-bold leading-tight text-white">Your journey to nikah <span className="text-amber-300">starts here.</span></h2>
              <p className="mt-2 max-w-md text-emerald-100/90">Seamlessly continue across web, Android and iOS with one account.</p>
              <div className="mt-5 flex flex-wrap gap-4 text-sm text-emerald-100/90">
                <span className="flex items-center gap-1.5"><ShieldCheck className="h-4 w-4 text-amber-300" /> Verified members</span>
                <span className="flex items-center gap-1.5"><Lock className="h-4 w-4 text-amber-300" /> Privacy first</span>
                <span className="flex items-center gap-1.5"><Smartphone className="h-4 w-4 text-amber-300" /> One account</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right form */}
        <div className="flex w-full flex-col justify-center px-6 py-10 sm:px-12 lg:w-1/2">
          <div className="mx-auto w-full max-w-md">
            <div className="mb-8 lg:hidden"><Link to="/"><Logo size="md" /></Link></div>
            <h1 className="font-serif text-4xl font-bold text-emerald-950">{title}</h1>
            {subtitle && <p className="mt-2 text-slate-600">{subtitle}</p>}
            <div className="mt-8">{children}</div>
            {footer && <div className="mt-6 text-center text-sm text-slate-600">{footer}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
